import { BlockBody, BlockContainer, BlockHeader } from '@medifind/containers';
import { useResultRouteQueryResponse } from '@medifind/hooks';
import { relatedClinicalTrialSearch } from '@medifind/interface';
import { useRouter } from '@medifind/router';
import { ClinicalTrialCardV3, Grid, ViewAllFooter } from '@medifind/search-results';
import { getNullList } from '@medifind/utils';
import { selectConditionFilter, useConditionFilter } from '@medifind/zustand';
import { selectRouteParams, useRouteStore } from '@medifind/zustand';

const SimilarClinicalTrials = ({ docId, size = 3, personId }) => {
  const { condition } = useConditionFilter(selectConditionFilter);
  const { codingType } = useRouteStore(selectRouteParams);

  const router = useRouter();
  const { codingSlug } = router.query;
  const projectId = router.query.projectId ?? condition.value;

  const { results, totalResults } = useResultRouteQueryResponse({
    queryKey: ['relatedClinicalTrialSearch', docId, projectId],
    queryFn: () => {
      return relatedClinicalTrialSearch({ relatedDocId: docId, size: size, projectId: projectId ?? condition.value });
    },
    enabled: !!docId,
  });

  return (
    <BlockContainer data-nosnippet>
      <BlockHeader priority={2}>Similar Clinical Trials</BlockHeader>
      <BlockBody noGutters={totalResults !== 0}>
        {totalResults !== 0 ? (
          <Grid
            items={(results || getNullList(size)).map((relatedArticle, i) => (
              <ClinicalTrialCardV3
                key={'clinical-trial-' + i}
                trial={relatedArticle}
                showDistance={location.lat && location.lon && location.fidelity <= 3}
                priority={3}
                hideIcon={true}
                projectId={projectId}
                codingSlug={codingSlug}
                codingType={codingType}
                showSummary={false}
                personId={personId}
                smallAt={['xs', 'xl', 'xxl']}
              />
            ))}
            size={results ? results.length : size}
            id={'related-clinical-trials'}
            maxColumnCount={1}
            noBorder
            addGutters
          />
        ) : (
          <>We couldn't find any related articles check for more on the main search page.</>
        )}
      </BlockBody>
      {process.env.NX_APP === 'MediFind' && projectId && (
        <ViewAllFooter to={`/${codingType === 'procedure' ? 'procedures' : 'conditions'}/${codingSlug}/${projectId}/clinical-trials`} />
      )}
    </BlockContainer>
  );
};

export { SimilarClinicalTrials as default, SimilarClinicalTrials };
